<template>
  <div style="width: 100%; height: 300px; position: relative">
    <canvas ref="doughnutChart"></canvas>
  </div>
</template>

<script>
export default {
  name: "DoughnutChart",
  props: ["data"],
  mounted() {
    let chartData = {
      labels: [],
      datasets: [
        {
          label: "Ovations by Month",
          data: [],
          backgroundColor: [
            "#e21f4c",
            "#3cc0c9",
            "#e0922f",
            "#1976D2",
            "#7FDBFF",
            "#3D9970",
          ],
        },
      ],
    };

    for (let category in this.data) {
      chartData.labels.push(category[0].toUpperCase() + category.substring(1));
      chartData.datasets[0].data.push(this.data[category]);
    }

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "right",
          labels: {
            boxWidth: 10,
            usePointStyle: true,
          },
        },
      },
    };

    let config = {
      type: "doughnut",
      data: chartData,
      options,
    };

    new Chart(this.$refs.doughnutChart, config);
  },
};
</script>
